import { z } from "zod";

/**
 * HCA Moravia — validační schémata pro `hca.dochazka` tRPC router.
 *
 * Docházka je 1:1 na přihlášku. Asistent v den semináře odkliká z tabletu.
 * `endSeminar` je transakčně orchestrovaný flip stavu termínu + propagace
 * na prihlaska.stavUcasti.
 */

/** Označení docházky jedné přihlášky — asistent upsertuje z tabletu. */
export const markAttendanceSchema = z.object({
  prihlaskaId: z.string().uuid("Neplatné ID přihlášky"),
  pritomen: z.boolean(),
  casPrichodu: z.coerce.date().optional(),
  poznamka: z.string().max(1000, "Poznámka musí být 1000 znaků nebo méně").optional(),
});

/** Bulk označení — tablet submission více řádků najednou. */
export const bulkMarkAttendanceSchema = z.object({
  terminId: z.string().uuid("Neplatné ID termínu"),
  items: z
    .array(
      z.object({
        prihlaskaId: z.string().uuid("Neplatné ID přihlášky"),
        pritomen: z.boolean(),
      }),
    )
    .min(1, "Alespoň jedna řádka je povinná")
    .max(50, "Maximálně 50 řádek v jedné dávce"),
});

/** Ukončení semináře — termin přejde na UKONCEN, stavUcasti propíše na přihlášky. */
export const endSeminarSchema = z.object({
  terminId: z.string().uuid("Neplatné ID termínu"),
});

/** Non-paginated list docházky pro daný termín. */
export const listDochazkaByTerminSchema = z.object({
  terminId: z.string().uuid("Neplatné ID termínu"),
});

/** ID-only schema. */
export const dochazkaIdSchema = z.object({
  id: z.string().uuid("Neplatné ID docházky"),
});

export type MarkAttendanceInput = z.infer<typeof markAttendanceSchema>;
export type BulkMarkAttendanceInput = z.infer<typeof bulkMarkAttendanceSchema>;
export type EndSeminarInput = z.infer<typeof endSeminarSchema>;
export type ListDochazkaByTerminInput = z.infer<typeof listDochazkaByTerminSchema>;
export type DochazkaIdInput = z.infer<typeof dochazkaIdSchema>;
